var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-file-input',{attrs:{"width":_vm.imageWidth,"btnColor":"mdb-color","btn-title":_vm.buttonName,"rounded":"","img":_vm.image,"src":_vm.imageSrc},on:{"getValue":_vm.getFileInputValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }